module.exports = __webpack_public_path__ + "media/images/logo/nuevo_logo_frg-04cca449cbd48192a9099399dbccfba0.jpeg";